var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-page" },
    [
      _c("hp-slider", { attrs: { data: _vm.sliderData } }),
      _vm._v(" "),
      _vm.data.news && _vm.data.news.length
        ? _c(
            "div",
            { staticClass: "home-page__section" },
            [_c("latest-news", { attrs: { data: _vm.data.news } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("hp-investors"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home-page__section home-page__section--big container" },
        [
          _c("div", { staticClass: "row" }, [
            _vm.data.events && _vm.data.events.length
              ? _c(
                  "div",
                  { staticClass: "col-default-6 col-tablet-12" },
                  [_c("hp-calendar", { attrs: { data: _vm.data.events } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-default-5 col-default-offset-1 col-tablet-offset-0 col-tablet-6 col-tablet-12",
              },
              [_c("hp-reports", { attrs: { data: _vm.reportsData } })],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "home-page__section" }, [
        _c(
          "div",
          { staticClass: "container u-all-padding--no" },
          [_vm._t("productions")],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home-page__section container" },
        [_vm._t("key-figures")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home-page__section home-page__section--big container" },
        [_c("hp-sustainability", { attrs: { data: _vm.data.sustainability } })],
        1
      ),
      _vm._v(" "),
      _vm.data.team && _vm.data.team.length
        ? _c(
            "div",
            { staticClass: "home-page__section" },
            [_c("hp-people", { attrs: { data: _vm.data.team } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home-page__section home-page__section--big container" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-default-3 col-tablet-12" },
              [
                _c(
                  "z-caption",
                  {
                    staticClass: "u-bottom-margin--m-important",
                    attrs: {
                      size: "xl",
                      tag: "h2",
                      uppercase: "",
                      weight: "900",
                    },
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.text.ourLife) },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "z-button",
                  {
                    attrs: {
                      tag: "a",
                      href: "/" + _vm.$root.lang + "/press-center/media-bank/",
                      kind: "text",
                      size: "m",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "right",
                        fn: function () {
                          return [
                            _c("z-icon", {
                              attrs: {
                                name: "arrow_long",
                                dir: "right",
                                width: "40",
                                height: "24",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.text.mediaBank) },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-default-3 col-tablet-4 col-mobile-12" },
              [
                _c("z-image", {
                  attrs: { src: "/images/main-page/life-1.png" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-default-3 col-tablet-4 col-mobile-12" },
              [
                _c("z-image", {
                  attrs: { src: "/images/main-page/life-2.png" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-default-3 col-tablet-4 col-mobile-12" },
              [
                _c("z-image", {
                  attrs: { src: "/images/main-page/life-3.png" },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }